import { render, staticRenderFns } from "./v-feedback.vue?vue&type=template&id=a39c6ce8&scoped=true&"
import script from "./v-feedback.vue?vue&type=script&lang=js&"
export * from "./v-feedback.vue?vue&type=script&lang=js&"
import style0 from "./v-feedback.vue?vue&type=style&index=0&id=a39c6ce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39c6ce8",
  null
  
)

export default component.exports